import type { WorkCalendar } from '@hana/work-calendar';
import type { MeePerson } from '../data';

// TODO: phiếu lương thật khi có dữ liệu lương (A). Số MẪU theo script board Mint-Mee (khối "Lương · SỐ MINH HOẠ"); chỉ của chính người xem.

interface Period {
  paid: string;
  base: number;
  ot: number;
}

/** 6 kỳ gần nhất, mới → cũ (khoá MM/yyyy). */
const PERIODS: Record<string, Period> = {
  '09/2026': { paid: '05/Oct/2026', base: 14_200_000, ot: 850_000 },
  '08/2026': { paid: '05/Sep/2026', base: 14_600_000, ot: 400_000 },
  '07/2026': { paid: '05/Aug/2026', base: 14_600_000, ot: 1_200_000 },
  '06/2026': { paid: '05/Jul/2026', base: 14_000_000, ot: 300_000 },
  '05/2026': { paid: '05/Jun/2026', base: 14_600_000, ot: 600_000 },
  '04/2026': { paid: '05/May/2026', base: 14_200_000, ot: 0 },
};
export const PAY_KEYS = Object.keys(PERIODS);

/** Hệ số công của người mẫu (MAITTN làm 58% kỳ). */
const FACTOR: Record<string, number> = { DAVID: 1, MAITTN: 0.58 };

export interface SlipLine {
  k: string;
  v: number;
}

export interface Slip {
  key: string;
  paid: string;
  income: SlipLine[];
  deduct: SlipLine[];
  totalIncome: number;
  totalDeduct: number;
  net: number;
  /** có tăng ca trong kỳ */
  hasOt: boolean;
}

export function slipOf(me: Pick<MeePerson, 'id' | 'manager'>, key: string): Slip {
  const p = PERIODS[key] ?? PERIODS[PAY_KEYS[0]!]!;
  const f = FACTOR[me.id] ?? 1;
  const income = (
    [
      ['Lương theo ngày công', p.base * f],
      ['Phụ cấp trách nhiệm', me.manager ? 3_000_000 : 0],
      ['Phụ cấp ăn trưa', 730_000],
      ['Làm thêm giờ', p.ot * f],
    ] as const
  )
    .filter(([, v]) => v > 0)
    .map(([k, v]) => ({ k, v: Math.round(v) }));
  const ins = 12_000_000 * f;
  const deduct = (
    [
      ['BHXH 8%', ins * 0.08],
      ['BHYT 1,5%', ins * 0.015],
      ['BHTN 1%', ins * 0.01],
      ['Thuế TNCN', me.manager ? 420_000 : 0],
    ] as const
  )
    .filter(([, v]) => v > 0)
    .map(([k, v]) => ({ k, v: Math.round(v) }));
  const totalIncome = income.reduce((s, r) => s + r.v, 0);
  const totalDeduct = deduct.reduce((s, r) => s + r.v, 0);
  return { key, paid: p.paid, income, deduct, totalIncome, totalDeduct, net: totalIncome - totalDeduct, hasOt: p.ot > 0 };
}

/** 14200000 → "14.200.000 ₫" */
export const vnd = (n: number): string => `${Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')} ₫`;
export const MASK = '•••••••• ₫';

/** Công chuẩn / công thực tế của kỳ — công chuẩn từ work-calendar (tblClientInfo); kỳ đã chốt nghỉ 1 ngày phép có lương. */
export function periodWork(cal: WorkCalendar, key: string, hasOt: boolean) {
  const [mm, yy] = key.split('/');
  const std = cal.standardDaysInMonth(`${yy}-${mm}`);
  return { std, actual: std - 1, paidLeave: 1, otHours: hasOt ? 2.25 : 0 };
}
